import React, { useEffect, useState, useContext } from 'react';
import { ReactComponent as DownPolygon } from 'Icons/downPolygon.svg';
import { isNullOrUndefined } from 'utils/Global';
import TemplateOption from './TemplateOption';
import { cloneDeep } from 'lodash';
import useRockFetchGet, { useRockFetchPost } from 'utils/RockFetch';
import ScreenWizardContext from 'components/main/screenExperimentWizard/ScreenWizardContext';

export default function DropDownWizardTemplate({
  onChange,
  disabled = false,
  showTemplateNameModal,
}) {
  const screenWizContext = useContext(ScreenWizardContext);
  const [showOptions, setShowOptions] = useState(false);
  const [selectedVal, setSelectedVal] = useState(screenWizContext.expTemplate);
  const [updateDelete, setUpdateDelete] = useState(true);
  const [nameValExpTemplates, setnameValExpTemplates] = useState([]);
  const [rockFetchPost] = useRockFetchPost();
  const [rockFetchGet] = useRockFetchGet();
  useEffect(() => {
    async function fetchTemplates() {
      const response: string[] = await rockFetchGet(
        '/api/ScreenExpWizard/templatenames',
        'get',
        undefined,
        true,
      );
      if (response != null) {
        screenWizContext.setTemplateNames(response);
      }
    }
    fetchTemplates();
  }, []);
  useEffect(() => {
    const templates = [];
    screenWizContext.templateNames.forEach((val) => {
      templates.push({
        name: val,
        id: val,
      });
    });

    setnameValExpTemplates(templates);
  }, [screenWizContext.templateNames]);

  useEffect(() => {
    setSelectedVal(screenWizContext.expTemplate);
  }, [screenWizContext.expTemplate]);

  async function updateFileName(filebody) {
    const tempName = screenWizContext.templateNames.find(
      (name) => name.toLowerCase() == filebody.newFileName.toLowerCase(),
    );

    if (!isNullOrUndefined(tempName)) {
      return;
    }
    const response = await rockFetchPost(
      '/api/screenExpWizard/updateTemplateName',
      filebody,
    );

    if (response != null) {
      return response;
    }
  }
  function deleteTemplateName(fileName) {
    showTemplateNameModal(fileName);
    return;
  }
  function toggleOptions() {
    if (disabled) {
      return;
    }
    setShowOptions((val) => !val);
    setUpdateDelete(true);
  }

  function discardUpdateName() {
    const templates = cloneDeep(screenWizContext.templateNames);

    screenWizContext.setTemplateNames([...templates]);
  }

  function onClickCustomOption(val) {
    if (!updateDelete) {
      return;
    }
    setSelectedVal(val);
    onChange(val);
    setShowOptions(false);
  }

  useEffect(() => {
    function handleClickOutside(e) {
      if (
        !e.target.classList.contains('custom-select-option') &&
        !e.target.classList.contains('custom-select-template') &&
        !e.target.classList.contains('custom-select-body') &&
        !e.target.classList.contains('custom-select-list') &&
        !e.target.classList.contains('custom-select-input') &&
        !e.target.classList.contains('custom-select-edit') &&
        !e.target.classList.contains('custom-select-apply') &&
        !e.target.classList.contains('close-edit-name') &&
        !e.target.classList.contains('close-apply-name') &&
        !e.target.classList.contains('custom-select-edit') &&
        !e.target.classList.contains('custom-select-delete')
      ) {
        setShowOptions(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
  return (
    <div
      id="controls-dropdownwizardtemplate-wrapper"
      data-testid="controls-dropdownwizardtemplate-wrapper"
      style={{ width: '85%', marginLeft: '42px', position: 'relative' }}
    >
      <div
        id="controls-dropdownwizardtemplate-selected"
        data-testid="controls-dropdownwizardtemplate-selected"
        style={{
          border: '1px solid black',
          height: '34px',
          color: isNullOrUndefined(selectedVal) ? '#C4C4C4' : '#000000',
          fontSize: '13px',
          padding: '0px 4px',
        }}
        className={`cursor-pointer flex flex-space-between flex-y-center custom-select-template ${
          disabled ? 'disabled-select-input' : ''
        }`}
        onClick={toggleOptions}
      >
        {isNullOrUndefined(selectedVal) ? 'Select Saved Wizard Setup' : selectedVal}
        <DownPolygon
          id="controls-dropdownwizardtemplate-arrow"
          data-testid="controls-dropdownwizardtemplate-arrow"
          className="flex"
        />
      </div>
      {showOptions && (
        <div
          id="controls-dropdownwizardtemplate-options"
          data-testid="controls-dropdownwizardtemplate-options"
          className="custom-select-body"
        >
          <ul
            id="controls-dropdownwizardtemplate-options-list"
            data-testid="controls-dropdownwizardtemplate-options-list"
            className="list-style-none custom-select-list"
          >
            {nameValExpTemplates?.map((item, i) => {
              function onChangeVal(val) {
                const oldFileName = item.name;
                const newFileName = val;
                item.name = val;

                const updateFile = {
                  oldFileName: oldFileName,
                  newFileName: newFileName,
                };
                updateFileName(updateFile);
              }

              return (
                <TemplateOption
                  key={`templateOptions-${i}`}
                  onClickCustomOption={onClickCustomOption}
                  onChangeVal={onChangeVal}
                  item={item}
                  deleteTemplate={deleteTemplateName}
                  discardUpdateName={discardUpdateName}
                />
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}
